import { getFilenameFromContentDispositionHeader } from '@/lib/files'
import { useFetch, type UseFetchOptions } from '@vueuse/core'
import { type MaybeRef } from 'vue'

export const useDownloadFile = (
    downloadUrlRef: MaybeRef<string>,
    options: UseFetchOptions = { immediate: false },
) => {
    // In the event if something is passed in options, we need to set it to false
    options.immediate = false

    const {
        data,
        execute,
        response,
        onFetchError,
        statusCode,
        isFetching: isDownloading,
    } = useFetch<Blob>(downloadUrlRef, options).blob()

    const download = async () => {
        await execute()

        if (response.value && response.value.ok && data.value) {
            const header = response.value.headers.get('Content-Disposition')
            const filename = getFilenameFromContentDispositionHeader(header)

            const href = URL.createObjectURL(data.value)
            const link = document.createElement('a')
            link.style.display = 'none'
            link.href = href
            link.setAttribute('download', filename ?? 'file')
            link.click()
            URL.revokeObjectURL(href)
        }
    }

    return {
        download,
        isDownloading,
        onFetchError,
        statusCode,
    }
}
